// removed by extract-text-webpack-plugin
module.exports = {"row_table":"components-tjcx-queryStudents-show-row_table-j5fBs","col_left":"components-tjcx-queryStudents-show-col_left-jUGJK","col_right":"components-tjcx-queryStudents-show-col_right-2I8hm","blue":"components-tjcx-queryStudents-show-blue-3jme4"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/queryStudents/show.css
// module id = 726
// module chunks = 0